import type { RouteRecordRaw } from 'vue-router';
export const routes: RouteRecordRaw[] = [
  {
    path: 'allocations-2',
    component: () => import('@/app/modules/allocations-2/views/allocations-2-index.vue'),
    meta: {
      layoutFeatures: {
        actionPanel: true,
      },
    },
  },
];
export default routes;
